import React from "react";
import './Home.css';
import {Link} from "react-router-dom";
import {ReactComponent as EndpointIcon} from './endpoint.svg';
import {ReactComponent as InfluxIcon} from './influx.svg';
import {ReactComponent as PostgresIcon} from './postgres.svg';
import {ReactComponent as GrafanaIcon} from './grafana.svg';
import {ReactComponent as RedisIcon} from "./Redis.svg";
import {ReactComponent as DocumentationIcon} from "./documentation.svg";

class Home extends React.Component {
    render() {
        return <div className="Home">
            <h1>Home</h1>
            <p>Welcome to the pilot cloud of the WAGO <b>IESSB</b> Innosuisse project.</p>
            <p>Note that this frontend as well as the API backend are actively developed and both are subject to <b>breaking changes</b> at any time.</p>

            <h2>Live status and values</h2>
            <p>Live status, latest values and the building descriptions for all endpoints can be retrieved on this website or using the REST API.</p>
            <Link className="Home-link" to="/endpoint"><EndpointIcon />&nbsp;Endpoints</Link>

            <h2>Time series data</h2>
            <p>Time series data can be retrieved directly from <a target="_blank" rel="noopener" href="https://www.influxdata.com/products/influxdb-overview">InfluxDB</a>.<br/>You can use the web frontend or retrieve data using an access token from InfluxDBs REST API.</p>
            <Link className="Home-link" to="/influx"><InfluxIcon />&nbsp;InfluxDB</Link>
            <Link className="Home-link" to="/grafana"><GrafanaIcon />&nbsp;Grafana</Link>

            <h2>Relational data</h2>
            <p>Relational data can be viewed and modified using the <a target="_blank" rel="noreferrer" href="https://www.adminer.org/de/">Adminer</a> database web frontend.</p>
            <Link className="Home-link" to="/adminer"><PostgresIcon />&nbsp;Database</Link>

            <h2>Realtime data</h2>
            <p>Realtime data can be viewed and modified using the <a target="_blank" rel="noreferrer" href="https://redis.io">Redis</a> key/value storage web frontend.</p>
            <Link className="Home-link" to="/redis"><RedisIcon />&nbsp;Redis</Link>

            <h2>Documentation</h2>
            <p>Documentation about Endpoint software stack and API as well as Cloud software stack and API.</p>
            <Link className="Home-link" to="/documentation"><DocumentationIcon />&nbsp;Documentation</Link>
        </div>
    }
}

export default Home;